module.exports = __webpack_public_path__ + "img/home_view_pager_004.4f086a68.png";